import React, { useEffect, useState } from 'react';
import { Perfil } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import SelectorSimple from '../../../../../shared/Components/Selectores/Simple';


export const SelectorPerfiles = (props:any) =>{
  console.log('props selector perfil ', props)
  let {data} = props;
  let [options, setOptions] = useState<any>(undefined)

  useEffect(()=>{
    if(data)
    {setOptions(getOptions())}
  },[data])
  
  const getOptions = () =>{
    return data.map((p: Perfil)=> { return { value: p.idPerfil, inputDisplay: p.perfil } })
  }

  return (
    <SelectorSimple {...props} options={options} name="selectPerfiles"/>
  )
}
export default SelectorPerfiles